import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FieldInfo } from './field-info.types';

@Component({
  selector: 'cs-field-info-popover',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './field-info-popover.component.html',
  styleUrl: './field-info-popover.component.scss',
})
export class FieldInfoPopoverComponent {
  @Input({ required: true }) info!: FieldInfo;
  @Output() closed = new EventEmitter<void>();
}
